import {useState} from 'react';
import {useNavigate} from 'react-router-dom';

import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import CircleIcon from '@mui/icons-material/Circle';
import Stack from '@mui/material/Stack';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';

import config from '../../config/config';
import useUser from '../../hooks/useUser';
import { formatLeadStatus } from '../../helpers/leads';
import { getPatientViewPath } from '../../helpers/patients';
import { formatProviderName } from '../../helpers/providers';
import { formatDate } from '../../helpers/dates';
import { formatPhoneNumber } from '../../helpers/stringUtils';
import { formatReferrerName } from '../../helpers/referrers';

import EditLeadButton from './EditLeadButton';
import LaunchIcon from '@mui/icons-material/Launch';
import LeadStatus from './LeadStatus';
import LeadHasUpdates from './LeadHasUpdates';
import LeadDuplicateStatus from './LeadDuplicateStatus';
import ProviderAvatar from '../providers/ProviderAvatar';

const LeadTableRow = props => {
  const {data} = props.row;
  const navigate = useNavigate();
  const user = useUser();
  const isMyPatient = (
    data?.patient
    && data?.provider?.id === user?.provider?.id 
    && (['COMPLETED_SIGNUP', 'SCHEDULED', 'EVALUATED'].includes(data?.status))
  );
  return (
    <>
      <TableRow 
        key={data.id} 
        onClick={
          props.notClickable || !props.onOpenLeadById 
          ? undefined
          : e => props.onOpenLeadById(e, data.id)
        }
        sx={{cursor: 'pointer', '&:hover': {opacity: '0.7'}}}
      >
        <TableCell align="center">
          <Stack direction='row' justifyContent='center' alignItems='center' gap={.25}>
            <LeadHasUpdates lead={data} />
            <LeadDuplicateStatus lead={data} />
          </Stack>
        </TableCell>
        <TableCell align="left">
          <Stack direction='row' alignItems='center' gap={1}>
            <LeadStatus lead={data} includeStep={true} />
          </Stack>
        </TableCell>
        <TableCell align="left">
            <strong>
              {
                isMyPatient
                ? <Button
                    variant='text'
                    size='small'
                    onClick={e => {
                      e.stopPropagation();
                      navigate('/providers' + getPatientViewPath(data.patient));
                    }}
                    sx={{paddingLeft: 0}}
                  >
                    <strong style={{fontSize: '0.656rem'}}>
                      {data.contact_first_name} {data.contact_last_name}
                    </strong>
                  </Button>
                : data.contact_first_name + ' ' + data.contact_last_name
              }
            </strong>
        </TableCell>
        <TableCell align='left'>
          {data?.provider 
            ? <Stack direction='row' alignItems='center' gap={1}>
              <ProviderAvatar 
                provider={data.provider}
                sx={{ width: 32, height: 32 }}
              /> 
              {formatProviderName(data.provider)} 
            </Stack>
            : <span style={{color: config().colors.error}}>Unassigned</span>
          }
        </TableCell>
        <TableCell align='left'>
          <div 
            style={{maxWidth: '150px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}}
          >
            {formatReferrerName(data?.referrer)}
          </div>
        </TableCell>
        <TableCell align="left">{data.contact_email}</TableCell>
        <TableCell align="center">{formatPhoneNumber(data.contact_phone)}</TableCell>
        <TableCell align="center">{formatDate(data.date_created)}</TableCell>
        <TableCell>
          <IconButton
            onClick={e => props?.onOpenLeadById(e, data.id)}
            size='small'
            color='primary'
          >
            <LaunchIcon />
          </IconButton>
        </TableCell>
      </TableRow>
    </>
  );
};

export default LeadTableRow;